(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** @type {Map<HTMLElement, () => void>} */
  const spinCleanups = new Map();

  /** @param {HTMLElement} root */
  function destroyTermsSpin(root) {
    const cleanup = spinCleanups.get(root);
    if (cleanup) {
      cleanup();
      spinCleanups.delete(root);
    }
    delete root.dataset.beyblingTermsSpinReady;
  }

  /** @param {HTMLElement} root */
  function initTermsSpin(root) {
    if (root.dataset.beyblingTermsSpinReady === 'true') return;

    const logo = root.querySelector('.beybling-terms-spin-bg__logo');
    if (!(logo instanceof HTMLElement)) return;

    if (REDUCED) {
      root.dataset.beyblingTermsSpinReady = 'true';
      return;
    }

    let angle = 0;
    let velocity = 0.1;
    let lastScrollY = window.scrollY;
    let rafId = 0;
    let running = false;

    const measureBounds = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const screenCentered = document.body.classList.contains('beybling-screen-centered');
      root.style.top = '0';
      // Match the text column: full viewport when screen-centered, otherwise
      // the content area to the right of the side nav.
      if (isDesktop && screenCentered) {
        root.style.left = '0';
        root.style.right = '0';
        root.style.width = '100%';
      } else if (isDesktop) {
        root.style.left = 'var(--beybling-side-nav-width, 220px)';
        root.style.right = '0';
        root.style.width = '';
      } else {
        root.style.left = '0';
        root.style.right = '0';
        root.style.width = '100%';
      }
      root.style.bottom = isDesktop ? '0' : 'var(--beybling-bottom-nav-height)';
    };

    const tick = () => {
      if (!running) return;

      velocity *= 0.94;
      velocity += 0.05;

      if (velocity > 16) velocity = 16;
      if (velocity < 0.08) velocity = 0.08;

      angle += velocity;
      logo.style.transform = `rotate(${angle}deg)`;
      rafId = window.requestAnimationFrame(tick);
    };

    const start = () => {
      if (running || document.hidden) return;
      running = true;
      rafId = window.requestAnimationFrame(tick);
    };

    const stop = () => {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = 0;
    };

    const onScroll = () => {
      const delta = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      velocity += Math.abs(delta) * 0.32;
    };

    const onVisibility = () => {
      if (document.hidden) stop();
      else start();
    };

    measureBounds();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measureBounds, { passive: true });
    document.addEventListener('visibilitychange', onVisibility);
    start();

    root.dataset.beyblingTermsSpinReady = 'true';

    const cleanup = () => {
      stop();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', measureBounds);
      document.removeEventListener('visibilitychange', onVisibility);
    };
    spinCleanups.set(root, cleanup);
  }

  function boot() {
    document.querySelectorAll('[data-beybling-terms-spin]').forEach((root) => {
      if (root instanceof HTMLElement) initTermsSpin(root);
    });
  }

  function restart() {
    document.querySelectorAll('[data-beybling-terms-spin]').forEach((root) => {
      if (root instanceof HTMLElement) destroyTermsSpin(root);
    });
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pagehide', () => {
    document.querySelectorAll('[data-beybling-terms-spin]').forEach((root) => {
      if (root instanceof HTMLElement) destroyTermsSpin(root);
    });
  });

  window.addEventListener('pageshow', (event) => {
    if (!document.body.classList.contains('beybling-terms-spin')) return;
    const root = document.querySelector('[data-beybling-terms-spin]');
    if (!(root instanceof HTMLElement)) return;

    const needsRestart =
      event.persisted ||
      (root.dataset.beyblingTermsSpinReady === 'true' && !spinCleanups.has(root));

    if (needsRestart) restart();
  });
})();
